import { useEffect, useState } from "react";
import { IPortin } from "../ICart";
import { useFetch } from "@hooks/useFetch";
import { getPortinRoute } from "@api-routes/eirSalesFacade";
import { getResponseToState, IPortinResponse } from "../mappers/getPortinMapper";

interface IParams {
    cartOfferId: number;
}

export const useGetPortin = (props: IParams) => {
    const { cartOfferId } = props;
    const [getPortinState, { get }] = useFetch();
    const [portinInfo, setPortinInfo] = useState<IPortin>();

    const getPortin = () =>
        get<IPortinResponse>(getPortinRoute(cartOfferId)).then((portinResponse) => {
            if (portinResponse) {
                const portin = getResponseToState(portinResponse);
                setPortinInfo(portin);
            }
        });

    useEffect(() => {
        getPortin();
    }, []);

    return { getPortinState, portinInfo };
};
